import React from 'react';
import ListContext from './ListContext';
import { IListHeader } from '../../../interfaces/common/IListHeader';

export default function ListHeader({ actions = null, children, handleSubmit, handleReset }: IListHeader) {
    return (
        <div className="list-header">
            {actions}
            <ListContext handleSubmit={handleSubmit} handleReset={handleReset}>
                {children}
            </ListContext>
        </div>
    );
}